import React from "react";
import Styles from "./Title.module.css";

function Title() {
  return (
    <div className={Styles.titleMain}>
      Whatsapp<span>+</span>
    </div>
  );
}

export default Title;
